import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SpecificationFilter, SpecificationFiltersResponse } from '../../types/filters';

export interface SpecFiltersState {
  categoryId: number | null;
  filters: SpecificationFilter[] | null;
  initialTotalCount: number | null;
  isLoading: boolean;
  isInitialised: boolean;
  error: boolean;
}

const initialState: SpecFiltersState = {
  categoryId: null,
  filters: null,
  initialTotalCount: null,
  isLoading: false,
  isInitialised: false,
  error: false,
};

export const specFiltersSlice = createSlice({
  name: 'specFilters',
  initialState,
  reducers: {
    initSpecFiltersState: (state, action: PayloadAction<number>) => {
      state.categoryId = action.payload;
    },
    loadingSpecFilters: (state) => {
      state.isLoading = true;
    },
    loadingSpecFiltersSuccess: (state, action: PayloadAction<SpecificationFiltersResponse>) => {
      state.filters = action.payload.data;
      state.initialTotalCount = action.payload.total_count;
      state.isInitialised = true;
      state.isLoading = false;
      state.error = false;
    },
    loadingSpecFiltersError: (state) => {
      state.isLoading = false;
      state.error = true;
    },
    setSpecFilters: (state, action: PayloadAction<SpecificationFilter[]>) => {
      state.filters = action.payload;
    },
    updateSpecFilter: (
      state,
      action: PayloadAction<{ specId: string; optionIndex: number; isSelected: boolean }>,
    ) => {
      state.filters?.forEach((filter) => {
        if (filter.spec_id === action.payload.specId) {
          filter.options.forEach((option, index) => {
            if (index === action.payload.optionIndex) {
              option.isSelected = action.payload.isSelected;
            }
          });
        }
      });
    },
    clearSpecFilters: (state) => {
      state.filters?.forEach((filter) => {
        filter.options.forEach((option) => {
          option.isSelected = false;
        });
      });
    },
  },
});

export const {
  initSpecFiltersState,
  loadingSpecFilters,
  loadingSpecFiltersSuccess,
  loadingSpecFiltersError,
  setSpecFilters,
  updateSpecFilter,
  clearSpecFilters,
} = specFiltersSlice.actions;

export default specFiltersSlice.reducer;
